import List from "@/components/list";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const AccountTableConfig = [
    {
      label: "日志类型",
      prop: "logTypeName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "模块",
      minWidth: "90",
      render: vo => {
        const item = vo.row;
        return <span domPropsInnerHTML={item.module}></span>;
      }
    }, 
    {
      label: "描述",
      prop: "operateDescription",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "方法",
      prop: "operateMethod",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "参数",
      prop: "operateParams",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "耗时(ms)",
      prop: "operateTime",
      minWidth: "90"
    },
    {
      label: "结果",
      prop: "result",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "ip",
      prop: "operateIp",
      showOverflowTooltip: true
    },
    {
      label: "设备",
      prop: "device",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作人",
      prop: "userName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作时间",
      prop: "operateDate",
      minWidth: "150",
      showOverflowTooltip: true
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
